<script >
import { ref, onBeforeMount } from 'vue-demi';
import { Rank } from '@fegobull/common-component';
import { PROTOCOL_TYPE } from '../common/scheme';
import useEtfRank from './useEtfRank';
import useChartData from './useChartData';
import useSelectStatus from './useSelectStatus';
import useRankCmp from './useRankCmp';
const __sfc_main = {};
__sfc_main.props = {
  theme: String,
  rankType: String,
  showHeader: Boolean,
  increaseType: String,
  market: String,
  upDownColor: Number,
  language: Number,
  count: Number,
  schemeType: String,
  schemeProtocol: {
    type: String,
    default: PROTOCOL_TYPE.MOOMOO
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useEnv
  } = require('@fegobull/webapi').use;
  const {
    isPreRender
  } = useEnv();
  const props = __props;

  // 定义一个股票列表
  const stockList = ref([]);

  /* 市场排行 */
  const {
    getEtfRank
  } = useEtfRank(props);

  /* 图表数据 */
  const {
    initChartData,
    chartDataMap
  } = useChartData(stockList, props.increaseType);

  /* 自选状态 */
  const {
    selfSelectedMap,
    initSelectStatus,
    setSelectStatus
  } = useSelectStatus(stockList);

  /* 组件配置 */
  const {
    headerConfig,
    itemClick,
    iconClick
  } = useRankCmp(props, setSelectStatus);
  onBeforeMount(async () => {
    if (isPreRender) {
      return;
    }
    stockList.value = await getEtfRank();
    initChartData();
    initSelectStatus();
  });
  return {
    stockList,
    chartDataMap,
    selfSelectedMap,
    headerConfig,
    itemClick,
    iconClick
  };
};
__sfc_main.components = Object.assign({
  Rank
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <div class="etf-rank">
        <Rank
            :dataSource="stockList"
            :chartDataMap="chartDataMap"
            :selfSelectedMap="selfSelectedMap"
            :header="headerConfig"
            :upDownColor="upDownColor"
            :theme="theme"
            @itemClick="itemClick"
            @iconClick="iconClick"
        />
    </div>
</template>

<style lang="less" scoped>
.etf-rank {
    height: auto !important;
}
</style>
